

































































import { mapGetters } from 'vuex'
import Card from '@/components/Card.vue'
import TripOverviewStop from './TripOverviewStop.vue'

export default {
  components: {
    Card,
    TripOverviewStop
  },
  props: {
    transport: { type: Object, required: true },
    multiStop: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['canUseCarrierTimesFeature']),
    origin() {
      return this.multiStop.singleStops[0]
    },
    destination() {
      return this.multiStop.singleStops[this.multiStop.singleStops.length - 1]
    },
    googleMapsURL() {
      const origin = encodeURI(this.origin.address.formatted)
      const destination = encodeURI(this.destination.address.formatted)
      return `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`
    },
    distance() {
      return Math.floor(this.multiStop.routeDistance / 1000)
    },
    pickupStart() {
      return this.canUseCarrierTimesFeature
        ? this.transport.carrierPickupStart
        : this.transport.pickupStart
    },
    pickupEnd() {
      return this.canUseCarrierTimesFeature
        ? this.transport.carrierPickupEnd
        : this.transport.pickupEnd
    },
    deliveryStart() {
      return this.canUseCarrierTimesFeature
        ? this.transport.carrierDeliveryStart
        : this.transport.deliveryStart
    },
    deliveryEnd() {
      return this.canUseCarrierTimesFeature
        ? this.transport.carrierDeliveryEnd
        : this.transport.deliveryEnd
    }
  }
}
